import * as React from 'react';
import ResolveModal, { ManualResolution } from 'task-manager/ResolveModal';
import { TaskManagerContext, useTaskManagerContext } from 'task-manager/TaskManagerContext';
import { openModal } from 'modal-core-components';
import { Task } from 'task-manager/types';
import { Button } from '@material-ui/core';
import { useStyles } from './TaskSidebar.styles';

type ResolveButtonProps = {
  task: Task;
};

const showResolveModal = (
  task: Task,
  resolveTask: TaskManagerContext['resolveTask'],
  resolutions: ManualResolution[],
) => {
  openModal(
    closeModal => (
      <ResolveModal
        resolutions={resolutions}
        onSubmit={(reason, note) => resolveTask(task, reason, note)}
        closeModal={closeModal}
      />
    ),
    { closeOnBackgroundClick: false },
  );
};

export const ResolveButton = ({ task }: ResolveButtonProps) => {
  const classes = useStyles();
  const jobType = task.job?.type;
  const { resolveTask, resolveTaskLoading, loggedInPerson, getManualTaskResolutions } =
    useTaskManagerContext();

  const taskAssignedToViewer = loggedInPerson.id === task.assignedPerson?.id;
  const taskPendingWork = task.status === 'PENDING_WORK';

  const manualTaskResolutions = getManualTaskResolutions(jobType, task.type, task.assigneeType);
  const hasManualResolution = manualTaskResolutions?.length > 0;

  const showResolutionButton = taskPendingWork && taskAssignedToViewer && hasManualResolution;

  const openModal = () => showResolveModal(task, resolveTask, manualTaskResolutions);

  if (showResolutionButton) {
    return (
      <Button disabled={resolveTaskLoading} onClick={openModal} className={classes.primaryButton}>
        Resolve
      </Button>
    );
  }
  return null;
};
